// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestsHint_root__XVhRD","noRequests":"RequestsHint_noRequests__3s2o2"};